import { memo } from 'react'
import { useAppDispatch } from 'store'
import { useCancelAllSpotState, useSpotOpenOrders } from 'store/spot/hooks'
import { updateModal } from 'store/app/actions/modalActions'
import { CancelAllButton } from 'components/Buttons/CancelAll'

export const SpotCancelAll = memo(() => {
  const dispatch = useAppDispatch()
  const openOrders = useSpotOpenOrders()
  const cancelAllState = useCancelAllSpotState()

  return (
    <CancelAllButton
      visible={openOrders?.length > 0}
      pending={cancelAllState}
      onClick={() => {
        dispatch(updateModal({ modal: 'cancel', open: true }))
      }}
    />
  )
})
